export default __webpack_public_path__ + "static/media/2.45535d29.webp";